var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconInfo = function SvgIconInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.271,
    height: 13.271,
    viewBox: "0 0 13.271 13.271",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(1034.105 -12846.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(-1384.872 12342.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    transform: "translate(351.467 505.086)",
    fill: "none",
    stroke: "#173a6d",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.936,
    cy: 5.936,
    r: 5.936,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.936,
    cy: 5.936,
    r: 6.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M3.107,6.347a3.34,3.34,0,0,1-1.652,1.66c-.3.068-.587-.112-.574-1.054L.9,4.015c0-.281-.024-.384-.1-.369A2.771,2.771,0,0,0,.22,4.2L0,3.934A4.036,4.036,0,0,1,1.736,2.27c.337-.076.494.306.482,1.122L2.166,6.279c-.01.342.059.425.127.411a1.774,1.774,0,0,0,.567-.577ZM2.051.554A.853.853,0,0,1,1.408,1.61.615.615,0,0,1,.648,1.1.869.869,0,0,1,1.274.021.634.634,0,0,1,2.051.554Z",
    transform: "translate(356.183 507.026)",
    fill: "#173a6d",
    stroke: "none"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_info.99fb0a01.svg";
export { ForwardRef as ReactComponent };